import React from 'react';
import { TypoGraphy } from './';

import { useInterval } from '../../hooks';

interface Props {
  url: string;
  time: number;
  title: string;
}

export const Music = ({ url, time, title }: Props) => {
  const [state, setState] = React.useState({
    progress: 0,
    currentSecond: 0,
  });

  useInterval(() => {
    setState({ currentSecond: state.currentSecond + 1, progress: state.progress + 100 / time });
  }, 1000);

  const getHourMinuteSecond = (second: number) => new Date(second * 1000).toISOString().substr(11, 8);
  return (
    <React.Fragment>
      <progress value={state.progress} max="100" />
      <div style={{ backgroundColor: 'rgba(0,0,0,0.5)', padding: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <video style={{ display: 'none' }} loop={true} muted={false} playsInline={true} controls={true} autoPlay={true}>
          <source src={url} type="video/mp4" />
        </video>
        <TypoGraphy size={24}>
          {getHourMinuteSecond(state.currentSecond)} / {getHourMinuteSecond(time)}
        </TypoGraphy>
        <TypoGraphy size={16}>{title}</TypoGraphy>
      </div>
    </React.Fragment>
  );
};
